module.exports = __webpack_public_path__ + "img/wechat-qrcode.4dc7e1bf.png";